/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Chip_LinkInputs */

const cs_import_progress_chip_link = /** @type {(inputs: Import_Progress_Chip_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit import`)
};

const en_import_progress_chip_link = /** @type {(inputs: Import_Progress_Chip_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open import`)
};

/**
* | output |
* | --- |
* | "Open import" |
*
* @param {Import_Progress_Chip_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_chip_link = /** @type {((inputs?: Import_Progress_Chip_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Chip_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_chip_link(inputs)
	return cs_import_progress_chip_link(inputs)
});